<template>
    <div>
        <div
            class="flex mr-6 mt-4"
            style="justify-content: end"
            @click="removeWebViewFromAndroid"
        >
            <v-icon>mdi-close</v-icon>
        </div>
        <div style="margin: auto; padding: auto" class="flex">
            <div style="flex-direction: column; margin-top: 10vh">
                <div>
                    <img :src="doodleImage" />
                </div>
            </div>
        </div>
        <div
            class="flex mt-4"
            style="
                flex-direction: column;
                word-wrap: break-word;
                text-align: center;
            "
        >
            <p style="font-weight: 600; font-size: 18px">
                आपका ऑर्डर अभी प्रोसेस हो रहा है
            </p>

            <small style="font-weight: 400; font-size: 18px" class="mr-4 ml-4">
                आपके पेमेंट की जानकारी अभी प्राप्त नहीं हो पा रही है। 24 घंटे के
                अंदर हम आपको सूचित करेंगे।आप इस पेज को बंद कर सकते हैं।
            </small>

            <small
                class="mr-4 ml-4 mt-2"
                style="font-weight: 400; font-size: 18px"
            >
                अन्य किसी भी सहायता के लिए {{ customerCareNo }} पर कॉल
                करें।</small
            >
        </div>
    </div>
</template>

<script>
import API_URL from "../../helpers/apiUrls";
import MoengageEventGenerator from '../../helpers/moengageEventGenerator';
import MoengageEvents from '../../helpers/moengageEvents';
export default {
    name: "paymentPending",
    data() {
        return {
            doodleImage: require("../../assets/logo/pending.svg"),
            // checkImage: require("../../assets/logo/greenCheck.svg"),
            customerCareNo: null,
            data: {
                razorpay_payment_id: null,
                razorpay_order_id: null,
                success: false,
                error_reason: null,
            },
        };
    },

    created() {
        this.customerCareNo = process.env.VUE_APP_CUSTOMER_CARE_NO;
        // console.log('order',this.orderDetails());
        const data = {
            razorpay_payment_id: this.$route.params.payId,
            razorpay_order_id: this.$route.params.orderId,
            success: false,
            error_reason: this.$route.params.reason,
        };
        if (data.razorpay_order_id && data.razorpay_order_id) {
            this.paymentConfirmation(data);
        } else {
            this.showToast("Something Went Wrong", "error");
        }
    },
    mounted() {
        this.setParamsFromRoute();
    },
    methods: {
        removeWebViewFromAndroid() {
            const moengageAttr={
                           ProductId:sessionStorage.getItem('pid'),
                            ProductName:sessionStorage.getItem('pname'),
                            BrandName:sessionStorage.getItem('brand-name'),
                            BrandId:sessionStorage.getItem('brand-id'),
                            ApiStatus:'',
                            Origin:'Web',
                            Action:'Dismissed'
                        }
                    MoengageEventGenerator(MoengageEvents.OrderPageAction,moengageAttr);
                    this.$gtag.event(MoengageEvents.OrderPageAction,moengageAttr);
                    Android.finishWebView();
                    
             },
        paymentSuccesOnAndroid() {
          
            Android.paymentSuccess(true);
        },
        orderDetails() {
            return this.$store.getters[
                "orderPaymentStore/GET_ORDER_FAILED_DETAILS"
            ];
        },
        setParamsFromRoute() {
            this.data.razorpay_payment_id = his.$route.params.payId;
            this.data.razorpay_order_id = his.$route.params.orderId;
            this.data.success = false;
            this.data.error_reason = his.$route.params.reason;
        },

        paymentConfirmation(payload) {
            const successHandler = (response) => {
                if (response.status === 200) {
                  //  console.log(response.data);
                    const moengageAttr={
                            ProductId:sessionStorage.getItem('pid'),
                            ProductName:sessionStorage.getItem('pname'),
                            BrandName:sessionStorage.getItem('brand-name'),
                            BrandId:sessionStorage.getItem('brand-id'),
                            BrandId:this.$store.getters["orderPaymentStore/GET_BRAND_DETAILS"].brandId,
                            ApiStatus:response.status,
                            Origin:'Web',
                            Error:this.data.error_reason
                        }
                    MoengageEventGenerator(MoengageEvents.OrderAPIStatus,moengageAttr);
                    this.$gtag.event(MoengageEvents.OrderAPIStatus,moengageAttr);
                    this.paymentSuccesOnAndroid()
                }
            };

            const data = payload;

            const errorHandler = (error) => {
                console.log(error.data);
                const moengageAttr={
                           ProductId:sessionStorage.getItem('pid'),
                            ProductName:sessionStorage.getItem('pname'),
                            BrandName:sessionStorage.getItem('brand-name'),
                            BrandId:sessionStorage.getItem('brand-id'),
                            ApiStatus:error.response.status,
                            Origin:'Web',
                            Error:this.data.error_reason
                        }
                MoengageEventGenerator(MoengageEvents.OrderAPIStatus,moengageAttr);
                this.$gtag.event(MoengageEvents.OrderAPIStatus,moengageAttr);
                this.showToast('Temporary Issue', "error",-1,true,'error');
            };

            this.requestPOST(
                API_URL.order_payment_confirmation,
                data,
                {},
                successHandler,
                errorHandler
            );
        },
    },
};
</script>

<style scoped>
.img {
    margin-left: 3.4rem;
}
</style>